import { ApplicationConfig } from '../lib/application';
import { useApplication } from './use-application';

export const useApplicationConfig = (key: keyof ApplicationConfig) => {
	return useApplication((state) => state.application.get(key));
};
